<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="search"></v-text-field>
      <v-btn class="ml-3 box-shadow" color="primary" @click="create_item_dialog = !create_item_dialog">Create new</v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-card>

        <v-data-table :headers="table_data.headers"
                      :items="table_data.items"
                      :search="search">
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="openSelectedItemDialog(item)">mdi-pencil</v-icon>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="create_item_dialog" max-width="500px">
        <v-form class="text-center" @submit="createItem">
          <v-card class="box-shadow">
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeCreateItemDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Create new</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text type="submit" color="success">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text>

              <v-text-field v-model="new_item.name" label="Name"
                            :error-messages="api_errors['name']"/>

              <v-text-field v-model="new_item.short_name" label="Short name"
                            :error-messages="api_errors['short_name']"/>

              <v-select v-model="new_item.weekday"
                        :items="weekday_options"
                        :error-messages="api_errors['weekday']"
                        label="Weekday"
                        required
              />
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="selected_item_dialog" max-width="500px">
        <v-form v-if="selected_item" @submit="updateSelectedItem">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeSelectedItemDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Settings</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-text-field v-model="selected_item.name" label="Name"
                            :error-messages="api_errors['name']"/>

              <v-text-field v-model="selected_item.short_name" label="Short name"
                            :error-messages="api_errors['short_name']"/>

              <v-select label="Weekday"
                        v-model="selected_item.weekday"
                        :items="weekday_options"
                        :error-messages="api_errors['weekday']"
                        required outlined
              />
            </v-card-text>
            <v-divider/>
            <v-card-actions class="justify-space-between">
<!--              TODO delete with dialog-->
              <v-btn class="box-shadow" color="red" dark >Delete</v-btn>
<!--              <v-btn class="box-shadow" color="red" dark @click="deleteSelectedItem">Delete</v-btn>-->
              <v-btn class="box-shadow" color="success" type="submit">Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data: () => ({
    table_data: {
      headers: [
        { text: 'Practice Area', value: 'name' },
        { text: 'Short Name', value: 'short_name' },
        { text: 'Weekday', value: 'weekday' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: []
    },
    weekday_options: [
      { text: 'Sunday', value: 0 },
      { text: 'Monday', value: 1 },
      { text: 'Tuesday', value: 2 },
      { text: 'Wednesday', value: 3 },
      { text: 'Thursday', value: 4 },
      { text: 'Friday', value: 5 },
      { text: 'Saturday', value: 6 },
    ],
    search: '',
    create_item_dialog: false,
    new_item: {
      name: null,
      short_name: null,
      weekday: 1,
    },
    selected_item_dialog: false,
    selected_item: null,

    api_errors: [],
  }),
  computed: {
    ...mapGetters({practice_areas: 'getPracticeAreas'}),
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/practice-areas`).then(({data}) => data.data)
    },
    closeCreateItemDialog() {
      this.create_item_dialog = false;
      this.new_item = {name: '', short_name: '', weekday: 1}
    },
    createItem(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post(`api/practice-areas`, {
        name: this.new_item.name,
        short_name: this.new_item.short_name,
        weekday: this.new_item.weekday,
      })
          .then(({data}) => {
            this.table_data.items.unshift(data.data)
            this.closeCreateItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
    },
    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
    updateSelectedItem(e) {
      e.preventDefault()
      this.api_errors = []
      let url = `api/practice-areas/${this.selected_item.id}`
      this.axios.put(url, {
        name: this.selected_item.name,
        short_name: this.selected_item.short_name,
        weekday: this.selected_item.weekday,
      })
          .then(() => {
            this.loadData()
            this.closeSelectedItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
    },
    deleteSelectedItem() {
      let url = `api/practice-areas/${this.selected_item.id}`
      this.axios.delete(url)
          .then(() => {
            this.closeSelectedItemDialog()
            this.loadData()
            this.$notify('Success', 'success')
          })
    }
  }
}
</script>